import type { SVGProps } from 'react';
const aircraftPlaneTakeOff = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M3.5 20.25a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H4.25a.75.75 0 0 1-.75-.75zM21.624 7.675c-.278-.591-.743-.945-1.296-1.067-.538-.118-1.124-.01-1.666.244l-4.834 2.272L7.302 5.18a1.125 1.125 0 0 0-1.06-.056l-.378.178a1.125 1.125 0 0 0-.269 1.859l4.292 3.814-2.126.999a.375.375 0 0 1-.311.003l-2.686-1.193c-.294-.13-.63-.129-.923.004l-.601.274a.75.75 0 0 0-.202 1.23l3.908 3.66c.335.314.828.393 1.244.2l12.176-5.671h.002c.541-.255.999-.638 1.25-1.128.26-.502.285-1.087.006-1.679z"
      fill={props.color ?? 'black'}
    />
  </svg>
);
export default aircraftPlaneTakeOff;
